module.exports = __webpack_public_path__ + "static/media/cosmonautBlack.b232095e.svg";